import jwtAxios from "@crema/services/auth/jwt-auth";
import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    SHOW_MESSAGE,
    GET_POLICIES_MANUALS,
    CREATE_POLICIES_MANUALS,
    UPDATE_POLICIES_MANUALS,
    GET_POLICIES_MANUALS_ITEM,
    CREATE_POLICIES_MANUALS_ITEM,
    UPDATE_POLICIES_MANUALS_ITEM,
    DELETE_POLICIES_MANUALS_ITEM,
    DELETE_POLICIES_MANUALS,
} from "shared/constants/ActionTypes";
import { HTTP_STATUS } from "shared/constants/AppConst";

export const getPoliciesManuals = (type) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get(`admin/get-all-manual/${type}`)
            .then((res) => {
                if (res.data.httpStatus === HTTP_STATUS.OK) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_POLICIES_MANUALS,
                        payload: res.data.data,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const createPolicyManuals = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post("admin/create-manual", data)
                .then((res) => {
                    if (res.data.httpStatus === "OK") {
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: CREATE_POLICIES_MANUALS,
                            payload: res.data.data,
                        });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};
export const updatePolicyManuals = (id, data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/update-manual/${id}`, data)
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({
                            type: UPDATE_POLICIES_MANUALS,
                            payload: { data: res.data.data, id: id },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};
export const deletePolicyManuals = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/delete-manual/${id}`)
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({
                            type: DELETE_POLICIES_MANUALS,
                            payload: { data: res.data.data, id: id },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};

// POLICIES & MANUALS CHILD ITEMS
export const getPoliciesManualsItem = (id, type) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("admin/get-all-user-manual", {
                params: {
                    manualId: id,
                    type: type,
                },
            })
            .then((res) => {
                if (res.data.httpStatus === HTTP_STATUS.OK) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_POLICIES_MANUALS_ITEM,
                        payload: res.data.data,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const createPolicyManualsItem = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post("admin/create-user-manual", data)
                .then((res) => {
                    if (res.data.httpStatus === "OK") {
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: CREATE_POLICIES_MANUALS_ITEM,
                            payload: res.data.data,
                        });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};
export const updatePolicyManualsItem = (id, data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/update-user-manual/${id}`, data)
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({
                            type: UPDATE_POLICIES_MANUALS_ITEM,
                            payload: { data: res.data.data, id: id },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};
export const deletePolicyManualsItem = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/delete-user-manual/${id}`)
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({
                            type: DELETE_POLICIES_MANUALS_ITEM,
                            payload: { id },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject();
                })
        );
    };
};
